import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'inline-block',
      margin: theme.spacing(1, 0),

      '&$highlighted': {
        boxShadow: `0 0 0 2px ${COLORS.primary.light}`,
      },
    },
    highlighted: {},
    image: {
      display: 'block',
      maxWidth: '100%',
      maxHeight: 300,
    },
  }),
  { name: 'ImageNode' }
);
